import "./TaskPriority.scss";
import { useTranslation } from "react-i18next";
import { translateLabel } from "../../../../i18n/defaultLabels";

function TaskPriority({
  updatePriority,
  selectedPriority,
  priorityConfig = [],
}) {
  const { t } = useTranslation();
  return (
    <div className="priority-content">
      {priorityConfig.map((priorityItem, index) => (
        <div
          key={priorityItem.label}
          className={`priority ${selectedPriority === index ? "selected" : ""}`}
          onClick={() => updatePriority(index)}
          style={{
            backgroundColor: priorityItem.color,
          }}
        >
          {translateLabel(priorityItem.label, t)}
        </div>
      ))}
      <hr className="separator" />
      <div className="clear-button" onClick={() => updatePriority(null)}>
        {t("common.clear")}
      </div>
    </div>
  );
}

export default TaskPriority;
